import { Helmet } from "react-helmet-async";
import { useSite } from "../../context/SiteContext";

const abs = (base, u) => (u.startsWith("http") ? u : `${base}${u}`);

export const Seo = ({ title, description, path, image = "/images/lunessa-og.jpg", breadcrumbs, noindex }) => {
  const { settings } = useSite();
  const base = (settings.site_url || window.location.origin).replace(/\/$/, "");
  const url = `${base}${path}`;
  const img = abs(base, image);
  const crumbs = breadcrumbs && {
    "@context": "https://schema.org",
    "@type": "BreadcrumbList",
    itemListElement: breadcrumbs.map((b, i) => ({ "@type": "ListItem", position: i + 1, name: b.label, item: `${base}${b.to}` })),
  };
  return (
    <Helmet>
      <html lang="tr" />
      <title>{title}</title>
      <meta name="description" content={description} />
      {noindex ? <meta name="robots" content="noindex, nofollow" /> : <meta name="robots" content="index, follow" />}
      <link rel="canonical" href={url} />
      <meta property="og:type" content="website" />
      <meta property="og:site_name" content="Lunessa Spa Masaj" />
      <meta property="og:locale" content="tr_TR" />
      <meta property="og:title" content={title} />
      <meta property="og:description" content={description} />
      <meta property="og:url" content={url} />
      <meta property="og:image" content={img} />
      <meta name="twitter:card" content="summary_large_image" />
      <meta name="twitter:title" content={title} />
      <meta name="twitter:description" content={description} />
      <meta name="twitter:image" content={img} />
      {crumbs && <script type="application/ld+json">{JSON.stringify(crumbs)}</script>}
    </Helmet>
  );
};
